import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    InputSignalWithTransform,
    OutputEmitterRef,
    booleanAttribute,
    input,
    output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BlockDirective, ElemDirective } from '@rt-tools/core';
import { RtToggleSwitchComponent } from '@rt-tools/ui-kit-v2';

let toggleAutoId: number = 0;
function nextToggleId(): number {
    toggleAutoId += 1;
    return toggleAutoId;
}
const BEM_BLOCK: string = 'sc-toggle';

// A labelled row around the kit switch: the kit switch draws no text of its own, and the site
// puts its label and a hint next to it. The label is tied to the switch, so a click on it
// toggles too.
@Component({
    selector: 'sc-toggle',
    templateUrl: './toggle.component.html',
    styleUrl: './toggle.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // angular
        FormsModule,

        // rt-tools
        BlockDirective,
        ElemDirective,

        // rt-tools ui-kit
        RtToggleSwitchComponent,
    ],
    host: {
        class: BEM_BLOCK,
        '[class.sc-toggle--on]': 'checked()',
        '[class.sc-toggle--disabled]': 'disabled()',
    },
})
export class ToggleComponent {
    protected readonly inputId: string = `sc-toggle-${String(nextToggleId())}`;

    public readonly checked: InputSignalWithTransform<boolean, unknown> = input.required<boolean, unknown>({
        transform: booleanAttribute,
    });
    public readonly label: InputSignal<string> = input.required<string>();
    public readonly disabled: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
        transform: booleanAttribute,
    });

    public readonly checkedChange: OutputEmitterRef<boolean> = output<boolean>();
}
